import type { IconSvgObject } from './types';

const OrigamiIcon: IconSvgObject = [
  ["path", { d: "M13 15L3 5L9 3L17 11L9 21V11.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17 11V3L13 7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M17 3L21 8H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default OrigamiIcon;
